var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar"},[_c('div',{staticClass:"container"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{staticClass:"d-inline-block align-text-top",attrs:{"src":require("@/assets/img/s2s_logo.png"),"alt":""}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }